
















import { Component, Vue, Prop } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import TextInput from "@/basics/inputs/TextInput.vue";

@Component({ components: { CButton, TextInput } })
export default class SearchForm extends Vue {
  @Prop({ type: String, required: false, default: undefined }) value!: string;
  @Prop({ type: String, required: false, default: "input" })
  placeholder!: string;

  tempValue = "";

  get inputValue() {
    return this.value === undefined ? this.tempValue : this.value;
  }

  input(value: string) {
    this.tempValue = value;
    this.$emit("input", value);
  }

  search() {
    this.$emit("search", this.inputValue);
  }
}
